import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";

export const ArticleCard = ({ article, index = 0 }) => (
  <Reveal delay={(index % 3) * 0.06}>
    <Link
      to={`/knowledge/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group block h-full rounded-[var(--cdt-radius-md)] bg-white border border-[color:var(--cdt-border)] shadow-[var(--cdt-shadow-sm)] hover:shadow-[var(--cdt-shadow-md)] transition-shadow overflow-hidden"
    >
      <div className="h-44 overflow-hidden">
        <img src={article.cover_image} alt={article.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500" />
      </div>
      <div className="p-5">
        <span className="inline-block text-[11px] font-semibold uppercase tracking-wider text-[var(--cdt-accent)]">{article.category}</span>
        <h3 className="font-display text-lg mt-2 text-[var(--cdt-text)] leading-snug">{article.title}</h3>
        <p className="mt-2 text-sm leading-6 text-[var(--cdt-muted)] line-clamp-2">{article.excerpt}</p>
        <div className="mt-3 flex items-center gap-1.5 text-xs text-[var(--cdt-muted)]">
          <Clock className="h-3.5 w-3.5" /> {article.read_minutes} min read
        </div>
      </div>
    </Link>
  </Reveal>
);
